import type { Props } from './Svg'
import { Svg } from './Svg'

export function ChevronRightIcon(props: Props) {
  return (
    <Svg width="18" height="18" {...props}>
      <path strokeWidth="2" d="M6.8 13.5 11.3 9 6.7 4.5" />
    </Svg>
  )
}
